import {useState} from "react";

const Header = props => {
    const [isOpen, setIsOpen] = useState(false);

    return <header className="site-header">
        <div className="container header-inner">
            <a className="brand" href="#top" aria-label="Контакт360">
                <span className="brand-mark"><span>К</span><b>360</b><i></i></span>
                <span className="brand-name">Контакт<span>360</span></span>
            </a>

            <button className="menu-toggle" type="button" aria-expanded={isOpen ? "true" : "false"} aria-controls="main-nav" onClick={() => {
                setIsOpen(true)
            }}>
                <span></span><span></span><span></span>
            </button>

            <nav className={"main-nav " + (isOpen ? "open " : "")} id="main-nav">
                <a href="#calculator" onClick={() => {
                    setIsOpen(false)
                }}>Калькулятор</a>
                <a href="#reports">Отчеты</a>
                <a href="#research">Исследование</a>
                <a href="#contacts">Контакты</a>
            </nav>

            <div className="header-contacts">
                <a href="tel:+79996200146">+7 (999) 620-01-46</a>
                <a href="mailto:vmv@yourtar.ru">vmv@yourtar.ru</a>
            </div>
        </div>
    </header>
}

export default Header;